// Comandos do agregado Insumo (Produtos/Insumos) — criar, editar,
// inativar/reativar. Dado puro; o executor só chama o domínio. `id` no `criar`
// vem do cliente (ADR-0003).

import type { Snapshot } from "../domain/snapshot.ts";
import {
  criarInsumo,
  definirAtivoInsumo,
  editarInsumo,
  type DadosInsumo,
} from "../domain/insumos.ts";
import { assertNunca } from "../lib/assert-nunca.ts";
import {
  comoObjeto,
  exigirBooleano,
  exigirTexto,
  texto,
} from "./_forma.ts";
import type { ContextoComando } from "./lotes.ts";

// O comando referencia `DadosInsumo` do domínio, não uma cópia (ADR-0013).
export type ComandoInsumo =
  | { tipo: "criar"; id: string; dados: DadosInsumo }
  | { tipo: "editar"; id: string; dados: DadosInsumo }
  | { tipo: "definirAtivo"; id: string; ativo: boolean };

export function executarComandoInsumo(
  snapshot: Snapshot,
  cmd: ComandoInsumo,
  _ctx: ContextoComando,
): Snapshot {
  switch (cmd.tipo) {
    case "criar":
      return criarInsumo(snapshot, cmd.dados, cmd.id);
    case "editar":
      return editarInsumo(snapshot, cmd.id, cmd.dados);
    case "definirAtivo":
      return definirAtivoInsumo(snapshot, cmd.id, cmd.ativo);
    default:
      return assertNunca(cmd);
  }
}

function validarDados(valor: unknown): DadosInsumo {
  const o = comoObjeto(valor, "Dados do insumo");
  return {
    nome: texto(o.nome),
    categoria: texto(o.categoria),
    unidade: texto(o.unidade),
    marca: texto(o.marca),
    fornecedor: texto(o.fornecedor),
  };
}

export function validarComandoInsumo(valor: unknown): ComandoInsumo {
  const c = comoObjeto(valor, "Comando de insumo");
  switch (c.tipo) {
    case "criar":
      return {
        tipo: "criar",
        id: exigirTexto(c.id, "id"),
        dados: validarDados(c.dados),
      };
    case "editar":
      return {
        tipo: "editar",
        id: exigirTexto(c.id, "id"),
        dados: validarDados(c.dados),
      };
    case "definirAtivo":
      return {
        tipo: "definirAtivo",
        id: exigirTexto(c.id, "id"),
        ativo: exigirBooleano(c.ativo, "ativo"),
      };
    default:
      throw new Error(`Tipo de comando de insumo desconhecido: ${String(c.tipo)}.`);
  }
}
